import { useQuery } from "react-query";
import { useRecoilState } from "recoil";
import { UserInfo, RightsDict, UserSearch, IpLocation } from "@/models/user";
import { me, getRightsList } from "@/services/user";

// 获取用户信息
export const useUserInfo = () =>  {
  // 用户信息
  const [userInfo, setUserInfo] = useRecoilState(UserInfo);

  // 处理刷新
  const refresh = async () => {
    // 获取数据
    const res: any = await me();
    // 赋值
    setUserInfo(res?.user);
  };

  return { userInfo, refresh };
};

// 获取权益字典
export const useRightsDict = () => {
  // 权益列表
  const [rightsDict, setRightsDict] = useRecoilState(RightsDict);

  // 处理获取
  const getRightsDict = async () => {
    // 获取数据
    const res: any = await getRightsList();
    setRightsDict(res?.list?.data);
  };

  return { rightsDict, getRightsDict };
};

// 用户搜索
export const useUserSearch = () => {
  // 用户搜索
  const [userSearch, setUserSearch] = useRecoilState(UserSearch);

  // 处理搜索
  const handleUserSearch = (user_id: number | string, mobile = '', activeKey = '1') => {
    setUserSearch({ ...userSearch, visible: true, user_id, mobile, activeKey });
  };

  return { handleUserSearch };
};

// Ip归属地查询
export const useIpLocation = () => {
  // Ip归属地
  const [ipLocation, setIpLocation] = useRecoilState(IpLocation);

  // 处理查询
  const handleIpLocation = (ip: string) => {
    // setIpLocation({ ...ipLocation, visible: true, ip });
  };

  return { handleIpLocation };
};
